export default {
	long: {
		ru: 'Русский',
		en: 'Английский',
		uk: 'Украинский',
		he: 'Иврит',
		pl: 'Польский',
		lv: 'Латвийский',
		lt: 'Литовский'
	},
	short: {
		ru: 'Рус',
		en: 'Анг',
		uk: 'Укр',
		he: 'Ивр',
		pl: 'Пол',
		lv: 'Лат',
		lt: 'Лит'
	},
	/**
	 * remove
	 */
	ru: 'Русский',
	en: 'Английский',
	uk: 'Украинский',
	he: 'Иврит',
	pl: 'Польский',
	lv: 'Латвийский',
	lt: 'Литовский'
}
